/* THE ADD TO CART BUTTON CARRIES THE PRICE.
 *
 * Mirrored from the price the page already shows, never rendered again. Two
 * renderings of one number is how they come to disagree — the visible price is
 * updated by the variant change, and a second Liquid copy would update only
 * when its own container happened to be morphed. Copying means the button can
 * never state a price the page does not.
 *
 * DELEGATED AND OBSERVED, because `variant-picker.js` morphs its subtree on
 * every selection and anything written once is undone by the next morph. The
 * observer is idempotent: it compares before it writes, so it cannot re-fire
 * on its own output — the mistake that locked the renderer when the off-ladder
 * notice repainted itself.
 */
(function () {
  'use strict';

  /* SCOPED TO THE PRODUCT'S OWN PRICE BLOCK, NOT TO THE FIRST PRICE IN THE
   * DOCUMENT. Below the desktop breakpoint Horizon renders the header's menu
   * drawer with a FEATURED PRODUCT CARD in it, and that card's price markup
   * precedes the product's in document order and is laid out, so an
   * unscoped first-visible-price read returned the featured product's price:
   * measured on rp11250 at 2026-09-19, the button read $83.14 while the page
   * read $366.25. Mirroring is still the rule — a second rendering is what
   * this file exists to avoid — but it must mirror THIS product's price.
   */
  var EXCLUDE = '.menu-drawer, cart-drawer, .cart-drawer, .resource-card';
  var SCOPE = '[id^="ProductInformation-"], .product-details, .product-information';
  var SETS = [
    'product-price .price-item__group.price, product-price .price-item--sale, product-price .price',
    '.price-item__group.price, .price-item--sale, .price'
  ];

  function visiblePrice(slot) {
    var scope = (slot && slot.closest && slot.closest(SCOPE)) || document;
    for (var s = 0; s < SETS.length; s++) {
      var nodes = scope.querySelectorAll(SETS[s]);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.closest && n.closest(EXCLUDE)) continue;
        if (n.offsetParent === null && n.getClientRects().length === 0) continue;
        var m = /[£$€₺]\s?[\d.,]+/.exec(n.textContent || '');
        if (m) return m[0].replace(/\s+/g, '');
      }
    }
    return null;
  }

  function paint() {
    var slots = document.querySelectorAll('[data-rz-atc-price]');
    if (!slots.length) return;
    for (var i = 0; i < slots.length; i++) {
      var p = visiblePrice(slots[i]);
      /* THE SEPARATOR IS A DASH, NOT A MIDDOT (2026-09-19). The label is a
       * claim and the number is its price — "Try Risk Free - $366.25" reads as
       * one sentence, which a middot between two nouns does not. */
      var want = p ? ' - ' + p : '';
      if (slots[i].textContent === want) continue;   /* idempotent */
      slots[i].textContent = want;
      slots[i].hidden = !p;
    }
  }

  /* RUG-FORK (storefront v2 round 6b, speed): ONE PAINT PER FRAME, AND ONLY FOR CHANGES
     INSIDE THE PRODUCT SECTION. `visiblePrice` reads layout (offsetParent / getClientRects),
     and this observer watched the whole document — so every node the parser, an app or a
     lazy section inserted forced a full style and layout pass: Lighthouse attributed ~5.7 s
     of main-thread work to this file on the product page. The price still follows the
     selection in the same frame (the morph and rug-instant-price both write inside SCOPE). */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; paint(); });
  }
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        var el = t && (t.nodeType === 1 ? t : t.parentElement);
        if (el && el.closest && (el.closest(SCOPE) || el.closest('[data-rz-atc-price]') || el.closest('.rz-sticky'))) { schedule(); return; }
      }
    }).observe(document.documentElement,
      { childList: true, subtree: true, characterData: true });
  }
  document.addEventListener('change', function () { setTimeout(paint, 60); }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else { paint(); }
})();
